module.exports = __webpack_public_path__ + "img/blood-icon-small.6fdd8862.webp";